import { z } from 'zod';

export const ChatResponseChunkSchema = z.object({
  text: z.string()
});

export type ChatResponseChunk = z.infer<typeof ChatResponseChunkSchema>;
